/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paymentprovidererror2Inputs */

const en_paymentprovidererror2 = /** @type {(inputs: Paymentprovidererror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The payment could not be processed. Please try again later.`)
};

const de_paymentprovidererror2 = /** @type {(inputs: Paymentprovidererror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zahlung konnte nicht verarbeitet werden. Bitte versuche es später erneut.`)
};

/**
* | output |
* | --- |
* | "The payment could not be processed. Please try again later." |
*
* @param {Paymentprovidererror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const paymentprovidererror2 = /** @type {((inputs?: Paymentprovidererror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paymentprovidererror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_paymentprovidererror2(inputs)
	return de_paymentprovidererror2(inputs)
});
export { paymentprovidererror2 as "paymentProviderError" }